module.exports = __webpack_public_path__ + "static/mail_outlook-6bbe325ad6da8ddcfe4298e51a3d93a2.png";